import jalaliMoment from 'jalali-moment';

export function persianDate(timestamp, format = 'jYYYY/jMM/jDD') {
  const date = new Date(timestamp);
  const jalaliDate = jalaliMoment(date);
  return jalaliDate.locale('fa').format(format);
}